import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ModuleName } from '../../enums/enums';
import { StockForm } from '../../forms/stock.form';
import { markControlsAsTouched } from '../../functions/mark-controls-as-touched';

@Component({
  selector: 'app-add-to-stock-modal',
  templateUrl: './add-to-stock-modal.component.html',
  styleUrls: ['./add-to-stock-modal.component.scss'],
  standalone: false,
})
export class AddToStockModalComponent implements OnInit, OnDestroy {
  title: string;
  form: StockForm;

  private subscription = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<AddToStockModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      id: string;
      currentStock: number;
      module: ModuleName.MEDICINE | ModuleName.STORAGE;
    }
  ) {
    this.form = new StockForm(this.data.id, this.data.currentStock);
    if (this.data.module === ModuleName.MEDICINE) {
      this.form.amount.setValue(1);
    }
  }

  ngOnInit(): void {
    this.subscription.add(
      this.form.amount.valueChanges.subscribe((amount: any) => {
        const parsedAmount = parseFloat(amount);
        const parsedCurrentStock = parseFloat(this.form.currentStock.value as any);
        this.form.newStock.setValue(parsedAmount + parsedCurrentStock);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  save(): void {
    markControlsAsTouched(this.form);

    if (!this.form.valid) {
      return;
    }

    this.dialogRef.close(this.form.value);
  }
}
